import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { CaseTracker } from "@/components/section8/CaseTracker";
import { HQSInspectionTab } from "@/components/section8/HQSInspectionTab";
import { RentReasonablenessTab } from "@/components/section8/RentReasonablenessTab";
import { VoucherMatchingTab } from "@/components/section8/VoucherMatchingTab";
import { ClipboardCheck, Search, DollarSign, Users } from "lucide-react";

export default function Section8() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-foreground">Section 8</h1>
        <p className="text-muted-foreground mt-1">
          Get properties approved, pass inspections, and match voucher tenants
        </p>
      </div>

      <Tabs defaultValue="cases" className="space-y-4">
        <TabsList>
          <TabsTrigger value="cases" className="gap-1.5">
            <ClipboardCheck className="h-4 w-4" /> Cases
          </TabsTrigger>
          <TabsTrigger value="inspections" className="gap-1.5">
            <Search className="h-4 w-4" /> HQS Inspections
          </TabsTrigger>
          <TabsTrigger value="rent" className="gap-1.5">
            <DollarSign className="h-4 w-4" /> Rent Analysis
          </TabsTrigger>
          <TabsTrigger value="vouchers" className="gap-1.5">
            <Users className="h-4 w-4" /> Voucher Matching
          </TabsTrigger>
        </TabsList>

        <TabsContent value="cases"><CaseTracker /></TabsContent>
        <TabsContent value="inspections"><HQSInspectionTab /></TabsContent>
        <TabsContent value="rent"><RentReasonablenessTab /></TabsContent>
        <TabsContent value="vouchers"><VoucherMatchingTab /></TabsContent>
      </Tabs>
    </div>
  );
}
